module.exports = __webpack_public_path__ + "img/44.217b683.jpg";